import { DatePipe } from "@angular/common";
import { Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RoutesRecognized,
} from "@angular/router";
import { OwlOptions } from "ngx-owl-carousel-o";
import { ToastrService } from "ngx-toastr";
import { API_ROUTES } from "src/app/core/_constants/api-route.constant";
import { ApiServicesService } from "src/app/services/apiServices/api-services.service";
// import { SubjectserviceService } from 'src/app/services/subjectService/subjectservice.service';
import { InterestedComponent } from "src/app/shared/dialogs/interested/interested.component";
import { PostPublishComponent } from "src/app/shared/dialogs/post-publish/post-publish.component";
import { Location } from "@angular/common";
import { CommonService } from "src/app/services/common.service";
import { ShareComponent } from "src/app/modules/pages/home/share/share.component";
import { RouteConstant } from "src/app/core/_constants/route.constant";
import { LocalStorageProvider } from "src/app/services/storage/storage.service";
import { filter, fromEvent, pairwise } from "rxjs";
import { SearchService } from "src/app/services/search.service";
import { DataService } from "src/app/services/data.service";
import { WhatsappServiceService } from "src/app/services/chatService/whatsapp-service.service";
import { environment } from "src/environments/environment";
import { AuthIdService } from '../../modules/pages/auth-id.service';
import { LogoutComponent } from "src/app/shared/dialogs/logout/logout.component";
import { FormBuilder, Validators } from "@angular/forms";
import { UtmLoginComponent } from "src/app/auth/utm-login/utm-login.component";
interface Media {
  url: string;
  media_type: string;
}
interface Industry {
  industry_name: string;
}

interface Product {
  id: string;
  title: string;
  location: string;
  price: number;
  Media: Media[];
  Industry: Industry;
  // Add any other properties you may have in the prod object
}

@Component({
  selector: 'app-product-detail',
  templateUrl: './product-detail.component.html',
  styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent {
  productData: any;
  images: any = [];
  videos: any = [];
  businessActivity: any = [];
  industry: any = [];
  pdf: any = [];
  productId: any;
  type: any;
  Media: any = [];
  imageObject: any = [];
  customOptions: OwlOptions = {
    loop: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    margin: 10,
    navSpeed: 700,
    navText: [
      '<img src="assets/images/home-1.svg" class="nav-icon">',
      '<img src="assets/images/home.svg" class="nav-icon">',
    ],
    autoplay: false,
    autoplayTimeout: 2000,
    items: 1,
    nav: true,
  };
  profileDetails: any;
  owner: boolean = false;
  status: any;
  guestUser: string | null;
  filter: any;
  category: any;
  hiddenInterestBtn: boolean = true;
  previousUrl: any;
  newArrivalsList: any;
  popularList: any;
  bestSellerList: any;
  otherProducts: any;
  productDetailScreen: any = "/" + RouteConstant.main + "/" + RouteConstant.marketPlaceList + "/" + RouteConstant.marketplaceProductDetail;
  filterAPIData: any;
  from: any;
  stoken: any;
  PeopleViewed: any;


  constructor(
    public datepipe: DatePipe,
    private dialog: MatDialog,
    private storageService: LocalStorageProvider,
    private service: ApiServicesService,
    private commonService: CommonService,
    private activeRoute: ActivatedRoute,
    private searchService: SearchService,
    private router: Router,
    private toastr: ToastrService,
    private dataService: DataService,
    private location: Location,
    private whatsAppService: WhatsappServiceService,
    private route: ActivatedRoute,
    private authIdService: AuthIdService, public dialogRef: MatDialog, private fb: FormBuilder,
  ) {
    if (this.productId) {
      this.productId = null;
      this.productData = null;
      this.profileDetails = null;
    }
    // let token = localStorage.getItem('stoken');
    // if (token) {
      this.activeRoute.queryParams.subscribe((params) => {
        this.productId = params?.["productId"];
        this.type = params?.["type"];
        this.status = params?.["status"];
        this.filter = params?.["filter"];
        this.category = params?.["category"];
        this.from = params?.["from"]
      });
    // } else {
      // this.service.Login();
    // }
  }
  onToggleChange(event: Event): void {
    // const checkbox = event.target as HTMLInputElement;
    // const control = this.loginForm.get('is_loan_required');
    // if (control) {
    //   control.setValue(checkbox.checked ? 'yes' : 'no');
    // } else {
    //   console.error(`controlName not found in form`);
    // }
  }
  isGetQuote: boolean;
  toggleGetQuote() {
   
    this.stoken = localStorage.getItem("stoken");
    if (this.stoken) {
      // Ensure productId is defined before proceeding
    if (!this.productId) {
      // console.error("productId is undefined");
      this.toastr.error("Product ID is missing.");
      return;  // Exit the function if productId is not defined
    }
    const payloadData = this.formData();
    // console.log(post, 'posttt');return;
    const url = API_ROUTES.MyRequirements.addToGetQuote;
    // For POST (Add to Wishlist), send the productId in the request body
    this.service.post(payloadData, url, {})
      .pipe()
      .subscribe({
        next: (res) => {
          // console.log(res, 'frf')
          if (res.success) {
            this.loginForm.get('is_loan_required').setValue('');
            this.loginForm.get('quantity').setValue('');
            // this.closeDialog();
            this.dialogRef.open(LogoutComponent, {
              maxHeight: '100vh',
              width: '50%',
              data: {
                img: '../assets/images/new_img/Group.svg',
                heading: 'Your Requirement has been shared with the seller',
                para: "Thank you for showing interest." +
                  "We will get back to you as soon as possible."
              }
            })
            setTimeout(() => {
              this.PeopleAlsoViewed();
            }, 1000);


            this.toastr.success(res.message);
            // console.log(res, 'added to quote');
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
  } else {
    
    if(this?.utmData?.utm_source){
      this.Login();
    }else{
      this.service.Login();
    }
  }
    
  }

  formData(){
    const post = this.loginForm.value;
    // console.log(post, 'posttt');
    if (post.is_loan_required == '') {
      delete post.is_loan_required;
    }
    if (post.is_loan_required === true) {
      post.is_loan_required = 'yes';
    } else if (post.is_loan_required === false) {
      post.is_loan_required = 'no';
    }
    if (post.quantity == '') {
      delete post.quantity;
    }
    const formattedData = {
      quotes: [
        {
          productId: this.productId, // Ensure this field exists in post
          quantity: post.quantity, // Default quantity if missing
          is_loan_required: post.is_loan_required,  // Default value
          ...this.utmData
        }
      ]
    };
    return formattedData;
  }

  Login() {
      const screenWidth = window.innerWidth;
      let isSmallScreen = true;
      if (screenWidth <= 1440) {
        isSmallScreen = true;
      }
      const payloadData = this.formData();
      const dialogRef = this.dialogRef.open(UtmLoginComponent, {
        maxHeight: '100vh',
        width: isSmallScreen ? '1000px' : '800px',
        data: { ...payloadData },
      })
  
    }
  goButtonBack(): void {
    this.location.back();
  }
  share() {
    const dialogRef = this.dialog.open(ShareComponent, {
      maxHeight: "100vh",
      width: "465px",
      panelClass: "yespost",
      data: {
        id: this.productId,
        type: 5,
        data: this.productData,
      },
    });
    this.storageService.setItem('product-url', window.location.href)
    dialogRef.afterClosed().subscribe(() => { });
  }
  // share() {
  //   if (this.guestUser) {
  //     this.commonService.guestUserPopup();
  //   } else {
  //     const dialogRef = this.dialog.open(ShareComponent, {
  //       maxHeight: "100vh",
  //       width: "465px",
  //       panelClass: "yespost",
  //       data: {
  //         id: this.productId,
  //         type: 3,
  //         data: this.productData,
  //       },
  //     });
  //     dialogRef.afterClosed().subscribe((result) => { });
  //   }
  // }


  PeopleAlsoViewed() {
    const apiEndpoint = API_ROUTES.Account.GETPEOPLEALSOVIEWED;
    //console.log('API expToken:', isUserLoggedIn);
    if (!apiEndpoint) return;

    const payload = {
      industry_id: this.productData?.industry_id,
      category3_id: this.productData?.category3_id,
    };

    this.service.post(payload, apiEndpoint, {}).subscribe({
      next: (response) => {
        const peopleViewedData = response;
        this.dialogRef.open(LogoutComponent, {
          maxHeight: '100vh',
          width: '75%',
          data: {
            img: '../assets/images/new_img/Group.svg',
            heading: 'People Also Viewed',
            para: 'Select and enquire for get quote',
            people: peopleViewedData,
            quote: true
          }
        });
        // setTimeout(() => {
        //           window.location.reload();
        // }, 2000);
      },
      error: (err) => {
        console.error('Error fetching People Viewed:', err);
      }
    });
  }



  closeDialog() {
    throw new Error("Method not implemented.");
  }
  loginForm: any;
  utmData: any;
  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.scrollTo(0, 0);
    this.guestUser = localStorage.getItem("guestUser");
    this.stoken = localStorage.getItem("stoken");
    // if (this.stoken) {
      // this.getProductDetails();
      this.route.queryParams.subscribe(params => {
        this.productId = params['productId'];
        // console.log("single");
        if (this.productId) {
          this.getProductDetails();
        }
      });
      this.openProduct();
    // } else {
      // this.service.Login();
    // }
    this.loginForm = this.fb.group({
      quantity: ['', [Validators.pattern('^[0-9]{1,5}$')]],
      is_loan_required: ['', []],
      productId: this.productId
    });
    this.route.queryParams.subscribe(params => {
      if (!params || typeof params !== 'object') return;
      const utmsourceValue = params['utm_source'] || '';
      const utmMediumValue = params['utm_medium'] || '';
      const utmCampaignValue = params['utm_campaign'] || '';
      const utmtermValue = params['utm_term'] || '';
      const utmcontentValue = params['utm_content'] || '';
      const utmplacementValue = params['utm_placement'] || '';
      this.utmData ={
        utm_source: utmsourceValue,
        utm_medium: utmMediumValue,
        utm_campaign: utmCampaignValue,
        utm_term: utmtermValue,
        utm_content: utmcontentValue,
        utm_placement: utmplacementValue
      };

    });

    this.service.pdpLoginStatus$.subscribe(status => {
      if (status) {
        this.submitUtmQuote();
      }
    });
  }

  submitUtmQuote(){
    const payloadData = this.formData();
    const url = API_ROUTES.MyRequirements.addToGetQuote;
      if (localStorage.getItem('stoken')) {
       this.service.post(payloadData, url, {})
          .pipe()
          .subscribe({
            next: (res) => {
              // console.log(res, 'frf')
              // if (res.success) {
                this.loginForm.get('is_loan_required').setValue('');
                this.loginForm.get('quantity').setValue('');

                this.service.emitPdpLoginStatus(false);
                this.dialogRef.open(LogoutComponent, {
                  maxHeight: '100vh',
                  width: '50%',
                  data: {
                    img: '../assets/images/new_img/Group.svg',
                    heading: 'Your Requirement has been shared with the seller',
                    para: "Thank you for showing interest." +
                      "We will get back to you as soon as possible."
                  }
                })
                setTimeout(() => {
                  this.PeopleAlsoViewed();
                }, 1000);
                this.toastr.success(res.message);
                // console.log(res, 'added to quote');
              // }
            },
            error: (error) => {
              this.toastr.error(this.commonService.returnErrorMessage(error));
            }
          });
      } else {
        // Dialog was closed without returning data (cancel or close button)
        console.log('OTP dialog closed without result');
      }
  }
  selectedImage: { url: string } | undefined;

  onImageClick(img: { url: string }) {
    this.selectedImage = img;  // Update the main image to the clicked small image
  }


  showInitial(names: any): string {
    let name = names?.replace(/\s+/g, ' ');
    if (!names) {
      return 'UK';
    }
    let result;
    const words = name.split(' ');
    if (words.length === 1) {
      // Extract the first two letters of the name and capitalize them
      result = name.slice(0, 1).toUpperCase() + name.slice(1, 2).toUpperCase();
    } else {
      // Extract the first letter of each word and capitalize them
      const initials = words.map((word: any) => word.charAt(0).toUpperCase());

      // Join the first two initials into a single string
      result = initials.slice(0, 2).join('');
    }

    return result;
  }


  openProduct() {
    this.dataService.product$.subscribe(res => {
      if (res?.productId) {
        this.productId = null;
        this.productId = res?.productId;
        this.type = res?.type;
        // this.getProductDetails();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    })
  }

  filterAPI() {
    this.service
      .get({}, API_ROUTES.MarketPlaceFilters.filters)
      .subscribe((res) => {
        if (res.success) {
          this.filterAPIData = res.result;
          this.businessActivity = this.filterAPIData.getIndustryList;
          this.industry = this.filterAPIData.getCategory1List;
        }
      });
  }

  // getChatLink(): string {
  //   return "https://wa.me/" + '919027146208' + '?text=http://localhost:4200/main/marketplace/grindingmachine?productId=0f1887e8-9324-4b4c-9648-6194d35afb36&type=2';
  // }

  shortLink: string = ''
  getChatLink() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    }
    else {
      let payload = {
        link: `https://web.raftaarr.com/main/marketplace/grindingmachine?productId=${this.productId}`,
        socialTitle: this.productData?.Category3 ? this.productData.Category3.title : this.productData?.Category2.title,
        socialDescription: this.productData.description,
        socialImageLink: this.productData.Media[0]?.media_type === 'video/mp4' ? this.productData.Media[0]?.thumbnail_url : this.productData.Media[0]?.url
          ? this.productData.Media[0]?.url
          : "https://raftaar-dev.s3.ap-south-1.amazonaws.com/Group%201000006538.png",
      };

      const url = this.productData.Media?.find((item: any) => item.media_type?.includes('image'))
      const videoUrl = this.productData.Media?.find((val: any) => val?.media_type?.includes('video'));
      if (url) {
        payload.socialImageLink = url?.url;
      } else if (videoUrl) {
        payload.socialImageLink = videoUrl?.thumbnail_url
      }
      //   this.service
      //     .post(payload, API_ROUTES.Home.externalShareLink, {})
      //     .pipe()
      //     .subscribe(
      //       (res) => {
      //         let json = JSON.parse(res.body);
      //         this.shortLink = json.shortLink;
      //         const phoneNumber = environment.clientWHatsAppChat;
      //         const message = `Hi, I'm interested in the product ${this.productData?.Category3 ? this.productData.Category3.title : this.productData?.Category2.title} listed here: ${this.shortLink} . Can we discuss this further?`;
      //         window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
      //       },
      //       (error) => {
      //         this.shortLink = "";
      //       }
      //     );
    }
  }

  openChat() {
    if (this.guestUser) {
      this.commonService.guestUserPopup();
    } else {
      if (window.innerWidth < 768) {
        this.router.navigate(
          [
            "/" +
            RouteConstant.main +
            "/" +
            RouteConstant.chat +
            "/" +
            RouteConstant.chatList,
          ],
          { queryParams: { type: 1 } }
        );
      } else {
        this.router.navigate(
          [
            "/" +
            RouteConstant.main +
            "/" +
            RouteConstant.chat +
            "/" +
            RouteConstant.chatScreen,
          ],
          { queryParams: { type: 1 } }
        );
      }
    }
  }
  navigatOnProfile() {
    // this.authIdService.setAuthId(this.productData?.auth_id);
    // this.router.navigate(['/main/company-profile']);
    this.router.navigate(['/main/company-profile'], {
      queryParams: { status: this.productData?.auth_id }
    });
  }

  getMarketPlaceGuestList(params: any) {
    this.service
      .get(params, API_ROUTES.Marketplace.marketPlaceGuestList)
      .pipe()
      .subscribe((res) => {
        if (res.success) {
          if (params.type && params.type == "popular") {
            this.popularList = res.result;

            for (let i = 0; i < this.popularList.length; i++) {
              let image = this.popularList[i].Media.find((element: any) =>
                element.media_type.toLowerCase().includes("image")
              );
              if (image) {
                this.popularList[i].shapeImageUrl = image.url;
              } else {
                this.popularList[i].shapeImageUrl =
                  "assets/images/placeholder-img.svg";
              }
              // if(this.popularList[i].Media && this.popularList[i].Media[0] && this.popularList[i].Media[0].media_type.toLowerCase().includes('image') ){
              //   this.popularList[i].shapeImageUrl = this.popularList[i].Media[0].url
              // }
              // else {
              //   this.popularList[i].shapeImageUrl='assets/images/placeholder-img.svg'
              // }
            }
          } else if (params.type && params.type == "bestseller") {
            this.bestSellerList = res.result;
            for (let i = 0; i < this.bestSellerList.length; i++) {
              let image = this.bestSellerList[i].Media.find((element: any) =>
                element.media_type.toLowerCase().includes("image")
              );
              if (image) {
                this.bestSellerList[i].shapeImageUrl = image.url;
              } else {
                this.bestSellerList[i].shapeImageUrl =
                  "assets/images/placeholder-img.svg";
              }
              // if(this.bestSellerList[i].Media && this.bestSellerList[i].Media[0] && this.bestSellerList[i].Media[0].media_type.toLowerCase().includes('image') ){
              //   this.bestSellerList[i].shapeImageUrl = this.bestSellerList[i].Media[0].url
              // }
              // else {
              //   this.bestSellerList[i].shapeImageUrl='assets/images/placeholder-img.svg'
              // }
            }
          } else {
            this.newArrivalsList = res.result;
            for (let i = 0; i < this.newArrivalsList.length; i++) {
              let image = this.newArrivalsList[i].Media.find((element: any) =>
                element.media_type.toLowerCase().includes("image")
              );
              if (image) {
                this.newArrivalsList[i].shapeImageUrl = image.url;
              } else {
                this.newArrivalsList[i].shapeImageUrl =
                  "assets/images/placeholder-img.svg";
              }
              // if(this.newArrivalsList[i].Media && this.newArrivalsList[i].Media[0] && this.newArrivalsList[i].Media[0].media_type.toLowerCase().includes('image') ){
              //   this.newArrivalsList[i].shapeImageUrl = this.newArrivalsList[i].Media[0].url
              // }
              // else {
              //   this.newArrivalsList[i].shapeImageUrl='assets/images/placeholder-img.svg'
              // }
            }
          }
        } else {
        }
      });
  }
  userauth_id: any;
  userProfile: any;
  getProfile() {
    // console.log("getProfile")
    this.service
      .get({}, `${API_ROUTES.More.moreDetails}`)
      .pipe()
      .subscribe(
        (res) => {
          if (res) {
            this.profileDetails = res.result[0];
            this.userProfile = res.result[res?.result?.length - 1];
            this.userauth_id = res.result[0].UserAuths[0].auth_id;
            // console.log(this.userauth_id);
            this.getProductDetails();
          }
        },
        (error) => {
          this.toastr.error(error.message);
        }
      );
  }

  interestedUsers() {
    // this.router.navigate(['/main/chat/chatHello'],{queryParams: {post_id:id}});
    this.router.navigate(
      [
        "/" +
        RouteConstant.main +
        "/" +
        RouteConstant.home +
        "/" +
        RouteConstant.interestedUser,
      ],
      { queryParams: { id: this.productId, type: 1 } }
    );
  }

  imageOnClick(ev: any) {
    for (let i = 0; i < this.imageObject.length; i++) {
      if (ev == i && this.imageObject[i].type == "pdf") {
        let element = document.createElement("a");
        element.setAttribute("href", this.imageObject[i].alt);
        // element.setAttribute('download', "a");
        document.body.appendChild(element);
        element.click();
      }
    }

  }


  toggleWishlist() {
    this.stoken = localStorage.getItem("stoken");
    if (this.stoken) {
      if (!this.productId) {
        this.toastr.error("Product ID is missing.");
        return;
      }
      this.isInWishlist = !this.isInWishlist;
      const url = this.isInWishlist
        ? API_ROUTES.Account.addToWishlist
        : API_ROUTES.Account.removewishlist;
      const httpMethod = this.isInWishlist ? 'post' : 'delete';
      if (httpMethod === 'post') {
        this.service[httpMethod]({ productId: this.productId }, url, {})
          .pipe()
          .subscribe({
            next: (res) => {
              if (res) {
                this.toastr.success(res.message);
              }
            },
            error: (error) => {
              this.toastr.error(this.commonService.returnErrorMessage(error));
            }
          });
      } else {
        const payload = { product_id: this.productId };
        this.service[httpMethod](payload, url)
          .pipe()
          .subscribe({
            next: (res) => {
              if (res) {
                this.toastr.success(res.message);
              }
            },
            error: (error) => {
              this.toastr.error(this.commonService.returnErrorMessage(error));
            }
          });
      }
    } else {
      this.service.Login();
    }
    
  }
  viweallrel: boolean = false;
  viweall: boolean = false;
  viwelessrel: boolean = false;
  viweless: boolean = false;
  isInWishlist: boolean;
  moreFromSeller: any[] = [];
  relatedProducts: any;
  cityDetails: any;
  stateDetails: any;
  ownUser: boolean = false;
  filteredspecification:any;
  getProductDetails() {
    this.ownUser = false;
    // console.log("getProductDetails");
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.productData = res?.result?.productDetails ?? res?.result;
            this.Media = this.productData.Media;
            this.stateDetails = this.productData.stateDetails;
            this.cityDetails = this.productData.cityDetails;
            if (this.productData.specifications) {
              this.filteredspecification = Object.entries(
                this.productData.specifications
              ).map(([key, value]) => ({
                key: this.formatKey(key),
                value,
              }));
            }

            // console.log(this.productData?.interestShown);
            this.isInWishlist = this.productData?.interestShown === true;
            // console.log("res.result from machine details page", res.result)
            if (this.service.userauth_id === this.productData?.auth_id) {
              this.ownUser = true;
            } else {
              this.ownUser = false;
            }
            this.moreFromSeller = res?.result?.moreFromSeller?.slice(0, 4);
            if (res?.result?.moreFromSeller?.length > 4) {
              this.viweall = true;
            }


            // console.log(this.moreFromSeller.length, 'machine data');
            this.relatedProducts = res?.result?.relatedProducts?.slice(0, 4);
            if (res?.result?.relatedProducts?.length > 4) {
              this.viweallrel = true;
            }
            this.Media = this.productData.Media;
            this.images = this.productData.Media;
            if (this.images && this.images.length > 0) {
              this.selectedImage = this.images[0];
            }
            // if (this.images && this.images.length > 0) {
            //   if(this.images[0].media_type == 'image/jpeg'){
            //     this.selectedImage = this.images[0];
            //   }else{
            //     this.selectedImage = this.images[1];
            //   }
            // }
            // this.moreFromSeller = res.result.moreFromSeller;
            // this.relatedProducts = res.result.relatedProducts;
            this.hiddenInterestBtn = this.productData?.interestShown || false;
            if (
              !this.guestUser &&
              this.productData.Auth?.CompanyInfo?.company_name?.toLowerCase() ===
              this.profileDetails?.company_name?.toLowerCase()
            ) {
              this.owner = true;
            }

            if (this.productData.Media && this.productData.Media.length > 0) {
              this.imageObject = this.commonService.slidesArranging(
                this.productData,
                this.productData.id
              );
            }

            // this.getPopularProducts();
            // this.getOtherproductsFromPopSeller();
          }
        },
        error: (error) => {
          if (error.error_code === 404) {
            this.toastr.error("Respective Product has been removed");
            this.router.navigate([
              "/" + RouteConstant.mainhome,
            ]);
          } else {
            this.toastr.error(this.commonService.returnErrorMessage(error));
          }
        },
        complete: () => {
          // Optionally handle completion here
        }
      });
  }

  formatKey(key: string): string {
    return key
      .split('_') // Split on underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize the first letter
      .join(' '); // Join the words with spaces
  }

  getStokanFromLocalStorage() {
    throw new Error("Method not implemented.");
  }



  viewSingleProduct(productId: string, category: string) {
    this.router.navigate([RouteConstant.productdetail], { queryParams: { productId: productId } }).then(() => {
      window.scrollTo(0, 0);
    });
  }

  goBack() {
    if (this.status != "ext") {
      if (this.filter) {
        if (this.category == "popular") {
          this.router.navigate(
            [
              "/" +
              RouteConstant.main +
              "/" +
              RouteConstant.marketPlaceList +
              "/" +
              RouteConstant.popularProducts,
            ],
            { queryParams: { filter: true } }
          );
        } else if (this.category == "best") {
          this.router.navigate(
            [
              "/" +
              RouteConstant.main +
              "/" +
              RouteConstant.marketPlaceList +
              "/" +
              RouteConstant.bestSellerProducts,
            ],
            { queryParams: { filter: true } }
          );
        } else {
          this.router.navigate(
            [
              "/" +
              RouteConstant.main +
              "/" +
              RouteConstant.marketPlaceList +
              "/" +
              RouteConstant.newArrivals,
            ],
            { queryParams: { filter: true } }
          );
        }
      } else {
        // if (localStorage.getItem('url')) {
        //   this.commonService.goBack();
        // }
        // else{
        // this.router.navigate(['/main/marketplace'])

        // }
        if (this.from === 'notification') {
          this.router.navigate(["/" + RouteConstant.main + "/" + RouteConstant.home + "/" + RouteConstant.notificationList])
        } else {
          this.router.navigate(['/main/marketplace'])
        }
      }
    } else {
      this.router.navigate([
        "/" + RouteConstant.main + "/" + RouteConstant.home,
      ]);
    }
  }

  profileView(data: any) {
    // if (this.guestUser) {
    //   this.commonService.guestUserPopup();
    // } else {
    //   if (data.auth_id == this.profileDetails.auth_id) {
    //     this.storageService.setItem("currentUser", "me");
    //     this.storageService.setItem("currentUserId", data.auth_id);
    //     this.router.navigate([
    //       "/" +
    //       RouteConstant.main +
    //       "/" +
    //       RouteConstant.profile +
    //       "/" +
    //       RouteConstant.about,
    //     ]);
    //   } else {
    //     this.storageService.setItem("currentUser", "other");
    //     this.storageService.setItem("currentUserId", data.auth_id);
    //     this.router.navigate([
    //       "/" +
    //       RouteConstant.main +
    //       "/" +
    //       RouteConstant.profile +
    //       "/" +
    //       RouteConstant.about,
    //     ]);
    //     this.searchService.changeProfile("other");
    //   }
    // }
  }

  getPopularProducts() {
    // const params = {
    //   auth_id: this.productData?.auth_id,
    //   product_id: this.productData?.id,
    //   category: this.productData?.category3_id,
    //   page: 1,
    //   size: 20
    // }
    // this.service.get(params, API_ROUTES.Marketplace.popularProducts).subscribe(res => {
    //   this.popularList = res.result;
    //   if (this.popularList) {
    //     for (let i = 0; i < this.popularList?.length; i++) {
    //       let image = this.popularList[i].Media.find((element: any) =>
    //         element.media_type.toLowerCase().includes("image")
    //       );
    //       if (image) {
    //         this.popularList[i].shapeImageUrl = image.url;
    //       }
    //       else if (
    //         this.popularList[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         )
    //       ) {
    //         let video = this.popularList[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         );

    //         this.popularList[i].shapeImageUrl = video.thumbnail_url
    //           ? video.thumbnail_url
    //           : "assets/images/placeholder-img.svg";
    //       } else {
    //         this.popularList[i].shapeImageUrl =
    //           "assets/images/placeholder-img.svg";
    //       }
    //     }
    //   }
    // })
  }

  getOtherproductsFromPopSeller() {
    // const params = {
    //   auth_id: this.productData?.auth_id,
    //   product_id: this.productData?.id,
    //   page: 1,
    //   size: 20
    // }
    // this.service.get(params, API_ROUTES.Marketplace.popularProducts).subscribe(res => {
    //   this.otherProducts = res.result;
    //   if (this.otherProducts) {
    //     for (let i = 0; i < this.otherProducts?.length; i++) {
    //       let image = this.otherProducts[i].Media.find((element: any) =>
    //         element.media_type.toLowerCase().includes("image")
    //       );
    //       if (image) {
    //         this.otherProducts[i].shapeImageUrl = image.url;
    //       }
    //       else if (
    //         this.otherProducts[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         )
    //       ) {
    //         let video = this.otherProducts[i].Media.find((element: any) =>
    //           element.media_type.toLowerCase().includes("video")
    //         );

    //         this.otherProducts[i].shapeImageUrl = video.thumbnail_url
    //           ? video.thumbnail_url
    //           : "assets/images/placeholder-img.svg";
    //       } else {
    //         this.otherProducts[i].shapeImageUrl =
    //           "assets/images/placeholder-img.svg";
    //       }
    //     }
    //   }
    // })
  }



  viewImage(url: any) {
    this.commonService.viewImage(url);
  }
  // interested() {
  //   if (this.guestUser) {
  //     this.commonService.guestUserPopup();
  //   } else {
  //     const screenWidth = window.innerWidth;
  //     let isSmallScreen = false;
  //     if (screenWidth <= 1440) {
  //       isSmallScreen = true;
  //     }
  //     const dialogRef = this.dialog.open(InterestedComponent, {
  //       maxHeight: "100vh",
  //       width: isSmallScreen ? "365px" : "465px",
  //       // panelClass:'products',
  //       data: {
  //         img: "assets/images/Success.png",
  //         heading: "Product Added Successfully",
  //         title: "Your product has been successfully added",
  //         btn: "Okay",
  //       },
  //     });
  //     dialogRef.afterClosed().subscribe((result) => {
  //       if (result) {
  //         if (
  //           result &&
  //           result.data != "" &&
  //           result.data != null &&
  //           result.data != undefined
  //         ) {
  //           let payload = {
  //             price: Number(result.data),
  //             loan_required: result.loan,
  //           };
  //           let param = {
  //             product_id: this.productData.id,
  //           };
  //           this.service
  //             .post(payload, `${API_ROUTES.Marketplace.showInterest}`, param)
  //             .pipe()
  //             .subscribe(
  //               (res) => {
  //                 const screenWidth = window.innerWidth;
  //                 let isSmallScreen = false;
  //                 if (screenWidth <= 1440) {
  //                   isSmallScreen = true;
  //                 }
  //                 const dialogRef = this.dialog.open(PostPublishComponent, {
  //                   maxHeight: "100vh",
  //                   width: isSmallScreen ? "365px" : "465px",
  //                   height: isSmallScreen ? "250px" : "400px",
  //                   panelClass: "resetPassword",
  //                   data: {
  //                     img: "assets/images/Completed_check.svg",
  //                     heading: "Your request has been sent",
  //                     title: "",
  //                     image: "assets/images/logout_3.svg",
  //                     btn: "Okay",
  //                   },
  //                 });
  //                 // this.hiddenInterestBtn=true;
  //                 dialogRef.afterClosed().subscribe((result) => {
  //                   this.getProductDetails();
  //                 });
  //               },
  //               (error) => {
  //                 // this.toastr.error(error.message)
  //                 this.toastr.error(
  //                   this.commonService.returnErrorMessage(error)
  //                 );
  //               }
  //             );
  //         }
  //         // else {
  //         //   const dialogRef=this.dialog.open(PostPublishComponent,{
  //         //     maxHeight: '100vh',
  //         //     width:'465px',
  //         //     height:'400px',
  //         //     panelClass:'resetPassword',
  //         //     data: {
  //         //       img:'assets/images/Completed_check.svg',
  //         //       heading:'',
  //         //       title:'Your request has been sent',
  //         //       image:'assets/images/logout_3.svg',
  //         //       btn:'Okay'
  //         //     }
  //         //   })
  //         //   dialogRef.afterClosed().subscribe(result => {
  //         //     this.getProductDetails();
  //         //   });
  //         // }
  //       }
  //     });
  //   }
  // }
  // edit(id: any) {
  //   this.router.navigate(
  //     [
  //       "/" +
  //       RouteConstant.main +
  //       "/" +
  //       RouteConstant.marketPlaceList +
  //       "/" +
  //       RouteConstant.editMarketPlaceProduct,
  //     ],
  //     { queryParams: { id: id } }
  //   );
  // }

  // slider(ev: any) {
  //   let videos = this.imageObject.filter((el: any) => el.type == "video");

  //   videos.forEach((el: any) => {
  //     let video: any = document.getElementById(el.id);
  //     video.pause();
  //     video.currentTime = 0;
  //   });
  // }

  viewAllProductsFromSeller(name: any) {
    this?.getAllProductsFromSeller(name);

  }
  viewLessProductsFromSeller(viewLessProducts: any) {
    this?.getAllProductsFromSeller(viewLessProducts);
  }
  viewAllProductsFromRelated(name: any) {
    this?.getAllProductsFromRelated(name)

  }
  viewLessProductsFromRelated(viewLessProduct: any) {
    this?.getAllProductsFromRelated(viewLessProduct)
  }

  getAllProductsFromSeller(productType: string) {
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.moreFromSeller = productType === 'lessFromSeller' ? res.result.moreFromSeller.slice(0, 4) : res.result.moreFromSeller;
            this.viweall = productType === 'lessFromSeller' ? true : false;
            this.viweless = productType === 'lessFromSeller' ? false : true
            // console.log("Full list from the seller", this.moreFromSeller);
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
  }

  getAllProductsFromRelated(productType: string) {
    let url = this.guestUser
      ? API_ROUTES.Marketplace.productDetailsGuest
      : API_ROUTES.Marketplace.productDetails;

    this.service
      .get({ productId: this.productId }, url)
      .pipe()
      .subscribe({
        next: (res) => {
          if (res.success) {
            this.relatedProducts = productType === 'lessrelatedProducts' ? res.result.relatedProducts.slice(0, 4) : res.result.relatedProducts;
            this.viweallrel = productType === 'lessrelatedProducts' ? true : false;
            this.viwelessrel = productType === 'lessrelatedProducts' ? false : true;
            // console.log("Full list of related products", this.relatedProducts);
          }
        },
        error: (error) => {
          this.toastr.error(this.commonService.returnErrorMessage(error));
        }
      });
  }

  allowOnlyNumbers(event: KeyboardEvent): void {
    const charCode = event.charCode;

    // Allow: 0–9 only (charCode 48 to 57)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
}
